import { render, staticRenderFns } from "./UploadEvidenceDetail.vue?vue&type=template&id=77927843&"
import script from "./UploadEvidenceDetail.vue?vue&type=script&lang=js&"
export * from "./UploadEvidenceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports